(ns frontend.test.nev-v3.view
  (:require [frontend.routing :as routing]))

(defn not-available
  []
  [:div "Page not available at the moment."])

(defn link-button
  []
  [:div
   {:class "flex items-center justify-center py-10 cursor-pointer px-20 bg-primary-regular rounded-xl shadow duration-200 hover:shadow-lg active:scale-[0.97]"
    :on-click #(routing/set-view! [:test-ribbon :ribbon-id 1234 :tab-id 2345])}
   [:p
    {:class "text-3xl font-bold text-white text-center"}
    "Click Here To Ribbon"]])

(defn view
  []
  (let [available? true]
    [:div.p-10.h-screen.flex.flex-col.items-center.justify-center
     (if available?
       [link-button]
       [not-available])]))

